<template>
  <div class="quiz_body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'QuizBody'
}
</script>

<style scoped>
  .quiz_body {
    margin: 0;
    background: #fff;
    border-radius: 0 0 48px 0;
    padding: 35px 50px 0 50px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    .quiz_body {
      padding: 40px 3% 3%;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }
</style>
